import { Component, input, output, type InputSignal, type OutputEmitterRef, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-back-navigation-label',
    styleUrls: ['./back-navigation-label.component.scss'],
    templateUrl: './back-navigation-label.component.html',
})
export class BackNavigationLabelComponent {
    public readonly title: InputSignal<string> = input.required<string>();

    public readonly back: OutputEmitterRef<void> = output<void>();
}
